import {request} from '../utils/request';
import {stencilApi} from '../config/urlConfig';

export const pageQueryReport = (data: any) =>
  request({
    url: `${stencilApi}/report/pageQuery`,
    method: "post",
    data
  })

export const updateReport = (data: any) =>
  request({
    url: `${stencilApi}/report/update`,
    method: "post",
    data
  })

export const addReport = (data: any) =>
  request({
    url: `${stencilApi}/report/insert`,
    method: "post",
    data
  })
